<template>
  <div class="Paylist">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right:-10px;color:rgba(52,152,219,1);"
        ></i>
        白条申请
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting(1)">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 70%;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
        <div class="remind-sms" @click="get_send_sms(1),dialogFormVisible3 = true"><span>短信提醒还款</span></div>
      </div>
      <div style="background-color:#fff;" class="search_box">
        <el-row class="search" :gutter="10">
          <el-col :span="2">
            <div class="label">所属用户:</div>
          </el-col>
          <el-col :span="5">
            <el-input v-model="s_mobile" clearable size="small" placeholder="所属用户"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">电话:</div>
          </el-col>
          <el-col :span="5">
            <el-input v-model="s_phone" clearable size="small" placeholder="电话"></el-input>
          </el-col>
          <el-col :span="6" align="center">
            <div class="filtrate_seek_sousuo" @click="geting(1)">搜索</div>
          </el-col>
        </el-row>
      </div>
      <div class="content_box">
        <div class="table_title">
          <div class="table_title_box">
            <div class="title_icon">
              <i class="fas fa-bars"></i>
            </div>
            <div class="title_text">数据列表</div>
          </div>
        </div>
        <div class="table">
          <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
            <el-table-column  label="所属用户" prop="user_mobile" align="center"></el-table-column>
            <el-table-column prop="name" label="姓名" align="center"></el-table-column>
            <el-table-column prop="phone"  label="电话" align="center"></el-table-column>
            <el-table-column prop="email"  label="邮箱" align="center"></el-table-column>
            <el-table-column prop="address"  label="地址" align="center"></el-table-column>
            <el-table-column prop="teacher"  label="导师" align="center"></el-table-column>
            <el-table-column prop="teacher_phone" label="导师电话" align="center"></el-table-column>
            <el-table-column prop="fixed_money"  label="固定额度" align="center"></el-table-column>
            <el-table-column prop="current_money"  label="剩余额度" align="center"></el-table-column>
             <el-table-column prop="status" label="审核状态" width="80" align="center">
               <template slot-scope="scope">
                 <el-tag type="success" v-if="scope.row.status ==1">已开通</el-tag>
                 <el-tag type="danger" v-else-if="scope.row.status ==2">已禁用</el-tag>
                 <el-tag type="info" v-else>未开通</el-tag>
              </template>
             </el-table-column>
            <el-table-column prop="member" width="90" label="审核员" align="center"></el-table-column>
            <el-table-column prop="sms_time" width="90" label="短信" align="center"></el-table-column>
            <el-table-column label="操作" width="200" align="center" name="bianji">
              <template slot-scope="scope">
                <button @click="check_auth(scope.row.id,1)" class="button1">开通</button>
                <button @click="check_auth(scope.row.id,2)" class="button1">禁用</button>
                <button @click="set_money(scope.row.id,scope.row.fixed_money,scope.row.current_money),dialogFormVisible2=true" class="button1">设置</button>
                <el-popover
                    placement="right"
                    width="750"
                    trigger="click"
                    @show="get_order_detail(scope.row.user_mobile)"
                    >
                    <el-table :data="gridData">
                      <el-table-column width="250" align="center" property="orderCode" label="单号"></el-table-column>
                      <el-table-column width="100" align="center" property="money" label="金额"></el-table-column>
                      <el-table-column width="100" align="center"  label="还款方式">
                        <span slot-scope="reference">
                            {{ reference.row.type ==1 ? '微信' : (reference.row.type ==2 ? '支付宝' : '余额支付') }}
                         </span>
                      </el-table-column>
                      <el-table-column width="300" align="center" property="created_date" label="时间"></el-table-column>
                    </el-table>
                    <span slot="reference">还款记录</span>
                  </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page_box clearfix">
          <div class="page">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              :current-page.sync="page"
              @current-change="setPage"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 确认采购 -->
    <el-dialog title="额度设置" :visible.sync="dialogFormVisible2" width="33%">
      <el-form>
        <el-form-item label="固定额度:">
          <el-input-number style="width:356px" v-model="fixed_money" step="0.1"></el-input-number>
        </el-form-item>
        <el-form-item label="剩余额度:">
          <el-input-number style="width:356px" v-model="current_money" step="0.1"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="set_money_submit()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 群发短信 -->
    <el-dialog title="短信提醒还款" :visible.sync="dialogFormVisible3" width="33%">
      <el-form>

        <p v-if="sms_list.length > 0" class="show-sms-user">
            <span v-for="(item,index) of sms_list" :key="index">{{item.phone}}--{{item.month}}月</span>
        </p>
        <p v-else>
          <span style="color:red">没有要短信提醒的用户或已经提醒过！</span>
        </p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="get_send_sms(2)" >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "../../assets/all.css";
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      mobile: "",
      username: this.$cookies.get("username"),
      token: this.$cookies.get("token"),
      tableData: [],
      total:0,
      page:1,
      sort: "",
      dialogFormVisible2:false,
      dialogFormVisible3: false,
      id:0,
      fixed_money:0,
      current_money:0,
      s_mobile:'',
      s_phone:'',
      gridData:[],
      sms_list:[]
    };
  },
  created() {
    this.$store.state.topActiveId = 11;
    this.$store.state.leftTitle = "白条申请";
    this.geting()
  },
  watch: {
    //监听全选状态
  },
  methods: {
    get_send_sms(type=1){
      var where = {
          username: this.username,
          token: this.token,
          type:type
        };
        this.axios
          .get(this.serve + "/admin/return_money_sms", {
            params: where
          })
          .then(res => {
            if (res.data.status == "success") {
              if(type == 2){
                 this.$message({
                  type:'success',
                  message: res.data.msg
                })
                this.dialogFormVisible3 = false;
              }else{
                this.sms_list = res.data.data
              }
            } else {
              this.$message({
                type:'error',
                message: res.data.msg
              })
            }
        });
    },
    get_order_detail(mobile){
      var where = {
          username: this.username,
          token: this.token,
          mobile:mobile,
        };
        this.axios
          .get(this.serve + "/admin/card_order_log", {
            params: where
          })
          .then(res => {
            if (res.data.status == "success") {
              this.gridData = res.data.data.results;
            } else {
            }
        });
    },
    geting(v=1){
        var where = {
          username: this.username,
          token: this.token,
          page:v,
          mobile:this.s_mobile,
          phone:this.s_phone
        };

        this.axios
          .get(this.serve + "/admin/apply_list", {
            params: where
          })
          .then(res => {
            this.tableData = [];
            if (res.data.status == "success") {
              this.tableData = res.data.data.results;
              this.total = res.data.data.total;
            } else {
            }
        });
    },
    setPage(v){
      this.page = v;
      this.geting(v)
    },
    set_money(id,fixed_money,current_money){
      this.id = id;
      this.fixed_money = fixed_money;
      this.current_money = current_money;
    },
    set_money_submit(){
       let that = this;
       this.$confirm('是否要设置该用户当前的额度?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.dialogFormVisible2 = true;
            var where = {
              username: this.username,
              token: this.token,
              id:this.id,
              fixed_money:this.fixed_money,
              current_money:this.current_money
            };
            this.axios
              .get(this.serve + "/admin/set_money", {
                params: where
              })
              .then(res => {
                if (res.data.status == "success") {
                  this.$message({
                    type:'success',
                    message: '设置成功！'
                  })
                  setTimeout(()=>this.dialogFormVisible2 = false,1000)
                  that.geting(that.page)
                } else {
                  this.$message({
                    type:'warning',
                    message: '未知错误'
                  })
                }
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消设置'
          });          
        });     
    },
    check_auth(id,status){
       if(id <=0 || id==''){
          this.$message({
            type:'warning',
            message: '参数错误'
          })
       }
      let that = this;
      var where = {
          username: this.username,
          token: this.token,
          id:id,
          status:status
        };
         this.$confirm('此操作将开通该用户白条支付的功能?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.axios
              .get(this.serve + "/admin/check_auth", {
                params: where
              })
              .then(res => {
                
                if (res.data.status == "success") {
                  setTimeout(function(){
                     window.location.reload;
                  },2000)
                  this.$message({
                    type:'success',
                    message: '开通成功！'
                  })
                  that.geting(that.page)
                } else {
                  this.$message({
                    type:'warning',
                    message: '未知错误'
                  })
                }
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消审核'
          });          
        });    

    }


  }
};
</script>
<style lang="scss">
.Paylist {
  background: #f5f5f5;
  color: #333;
  min-height: 1000px;
  padding-bottom: 100px;
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu1 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      margin-right: 0;
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search_box {
    border: 1px solid rgba(221, 221, 221, 1);
    padding-left: 0px;
  }
  .search {
    display: flex;
    justify-content: left;
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
.content_box{
  width: 100%;
}
.remind-sms{
    float: right;line-height: 46px;padding-right: 10px;
    span{
      border: 2px solid #3498db;
      border-radius: 5px;
      padding: 2px 8px;
      cursor: pointer;
    }
}
.show-sms-user span{
  border:1px solid rgb(99, 87, 87);
  margin-right: 8px;
}
.subTitle{
  width:70%;
}
</style>